import TabAnagraficaPercorsi from "./TabAnagraficaPercorsi";
import TabTratti from "./TabTratti";
import TabGeometrieTratte from "./TabGeometrieTratte";

/**
 * Tab "Anagrafiche": raccoglie le due anagrafiche in due sotto-tab (task 517).
 *  - Anag. Percorsi -> community Interacta 121 (TabAnagraficaPercorsi, invariato)
 *  - Anag. Tratte   -> community Interacta 120 (TabTratti, invariato)
 *  - Geometrie tratte -> inizio, fine e disegno delle tratte dagli archi QGIS del
 *    cliente, da validare (TabGeometrieTratte; solo DB locale)
 *
 * Il sotto-tab attivo è "controllato" dal contenitore (GestionePercorsi.js): lì servono
 * titolo, sottotitolo e testo del modale "i" della singola anagrafica.
 * Markup dei sotto-tab come SezioneMulte.js; stile in GestionePercorsi.css (.gp-subtabs).
 */
const SOTTO_TAB = [
    { key: "anagPercorsi", label: "Anag. Percorsi" },
    { key: "tratti", label: "Anag. Tratte" },
    { key: "geometrie", label: "Geometrie tratte" },
];

const TabAnagrafiche = ({ zona, sub, onChange }) => (
    <>
        <div className="gp-subtabs">
            {SOTTO_TAB.map((s) => (
                <button
                    key={s.key}
                    className={`gp-subtab ${sub === s.key ? "active" : ""}`}
                    onClick={() => onChange(s.key)}
                >
                    {s.label}
                </button>
            ))}
        </div>

        {sub === "anagPercorsi" && <TabAnagraficaPercorsi zona={zona} />}
        {sub === "tratti" && <TabTratti zona={zona} />}
        {sub === "geometrie" && <TabGeometrieTratte zona={zona} />}
    </>
);

export default TabAnagrafiche;
